import ContentTemplate from '../../components/ContentTemplate';
import { buildPrimaryPostPage } from '../../util/buildPrimaryPostPage';
import { Layout } from '../agents/[[...slug]]';

const { getStaticProps, getStaticPaths, WrappedPage } =
    await buildPrimaryPostPage({
        site: 'AGENTS',
        basePath: '/workspace',
        useBasePathForId: true,
        ContentComponent: ContentTemplate,
        LayoutComponent: Layout,
        knotchAccountId: process.env.NEXT_PUBLIC_KNOTCH_PA_LAYOUT_ACCOUNT_ID,
        contentType: 'B2C',
        menuPropName: 'submenu',
    });

export { getStaticProps, getStaticPaths };
export default WrappedPage;
